module.exports = __webpack_public_path__ + "static/media/darkforces3.d1322e25.gif";